"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSearchResultBlock = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSearchResultBlock = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  cursor: pointer;
  border: 1px solid ${ui_components_1.baseColors.primaryBlueMed200};
  border-radius: 4px;
  padding: ${({ theme }) => theme.spacing(1, 2)};

  &.search-result-block--selected {
    border-color: ${ui_components_1.baseColors.primaryGreen300};
    background-color: ${ui_components_1.baseColors.primaryTeal100};
    cursor: default;
  }

  .search-result-block-title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: inherit;
  }

  .search-result-block-title {
    font-size: 1.25rem;
    font-weight: 700;
    cursor: inherit;
  }

  .search-result-block-description {
    color: ${({ theme }) => theme.palette.accent.main};
    font-size: 1rem;
    line-height: 1.5rem;
  }
`;
